import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../../core/auth/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.html',
  styleUrl: './login.css'
})
export class LoginComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  isLoggingIn = false;
  errorMessage: string | null = null;

  ngOnInit(): void {
    this.isLoggingIn = false;

    this.authService.authError$.subscribe((message) => {
      this.errorMessage = message;

      if (message) {
        this.isLoggingIn = false;
      }
    });

    this.route.queryParams.subscribe((params) => {
      if (params['error'] === 'unauthorized' && !this.errorMessage) {
        this.errorMessage = 'Acesso não autorizado';
        this.isLoggingIn = false;
      }
    });
  }

  async onMicrosoftLogin(): Promise<void> {
    if (this.isLoggingIn) {
      return;
    }

    this.isLoggingIn = true;
    this.errorMessage = null;
    this.authService.clearAuthError();

    try {
      await this.authService.login();
    } catch (error) {
      console.error(error);
      this.errorMessage = 'Não foi possível iniciar o login.';
      this.isLoggingIn = false;
    }
  }

  async onLoginWithAnotherAccount(): Promise<void> {
    if (this.isLoggingIn) {
      return;
    }

    this.isLoggingIn = true;
    this.errorMessage = null;
    this.authService.clearAuthError();

    try {
      await this.authService.loginWithAnotherAccount();
    } catch (error) {
      console.error(error);
      this.errorMessage = 'Não foi possível iniciar o login com outra conta.';
      this.isLoggingIn = false;
    }
  }
}